"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Point_1 = require("../../Utility/Point");
const Bind_1 = require("../../Utility/Decorator/Bind");
require("../../Druid");
/**
 * How to use:
 *
 * <code>new Draggable(element, {handle: handle, ...}).attach();</code>
 *
 * @see DragOptions for more configuration options
 */
class Draggable {
    constructor(element, options) {
        this.element = element;
        this.mouseStart = Point_1.default.ZERO;
        this.options = { ...{ handle: element, threshold: 6 }, ...options };
    }
    getOptions() {
        return this.options;
    }
    attach() {
        this.options.handle.addEventListener('mousedown touchstart', this.start);
        return this;
    }
    detach() {
        this.options.handle.removeEventListener('mousedown touchstart', this.start);
        return this;
    }
    start(event) {
        this.mouseStart = Draggable.pointFromEvent(event);
        if (this.options.onStart) {
            this.options.onStart();
        }
        document.addEventListener('mousemove touchmove', this.check);
        document.addEventListener('mouseup touchend', this.cancel);
    }
    check(event) {
        const distance = this.mouseStart.distance(Draggable.pointFromEvent(event));
        // dragged distance is below the threshold distance
        if (distance <= this.options.threshold) {
            return;
        }
        if (this.options.onDragStart) {
            this.options.onDragStart();
        }
        // remove previous listeners
        document.removeEventListener('mousemove touchmove', this.check);
        document.removeEventListener('mouseup touchend', this.cancel);
        // add new listeners
        document.addEventListener('mousemove touchmove', this.dragMove);
        document.addEventListener('mouseup touchend', this.dragStop);
    }
    cancel() {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.finishDrag();
    }
    dragMove(event) {
        const mouseCurrent = Draggable.pointFromEvent(event);
        // calculate the distance from the starting position
        const dx = mouseCurrent.x - this.mouseStart.x;
        const dy = mouseCurrent.y - this.mouseStart.y;
        if (this.options.onDragMove) {
            this.options.onDragMove({ dx, dy }, this.element);
        }
    }
    dragStop() {
        if (this.options.onDragStop) {
            this.options.onDragStop();
        }
        this.finishDrag();
    }
    finishDrag() {
        document.removeEventListener('mousemove touchmove', this.check);
        document.removeEventListener('mouseup touchend', this.cancel);
        document.removeEventListener('mousemove touchmove', this.dragMove);
        document.removeEventListener('mouseup touchend', this.dragStop);
        if (this.options.onComplete) {
            this.options.onComplete();
        }
    }
    static pointFromEvent(event) {
        // sniff on event type instead of `instanceof TouchEvent` as desktop browsers might not have TouchEvent obj
        if (event.type.startsWith('touch')) {
            return new Point_1.default(event.touches[0].clientX, event.touches[0].clientY);
        }
        return new Point_1.default(event.clientX, event.clientY);
    }
}
exports.default = Draggable;
__decorate([
    Bind_1.default
], Draggable.prototype, "start", null);
__decorate([
    Bind_1.default
], Draggable.prototype, "check", null);
__decorate([
    Bind_1.default
], Draggable.prototype, "cancel", null);
__decorate([
    Bind_1.default
], Draggable.prototype, "dragMove", null);
__decorate([
    Bind_1.default
], Draggable.prototype, "dragStop", null);
//# sourceMappingURL=Draggable.js.map